export default __webpack_public_path__ + "static/media/guia-sos-aprova-2026.f4ce9d27.jpg";